import * as Types from '../../generated.types'

import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type PublicOrganizationQueryVariables = Types.Exact<{
  inviteCode: Types.Scalars['String']
}>

export type PublicOrganizationQuery = {
  __typename?: 'Query'
  publicOrganization?: {
    __typename?: 'PublicOrganization'
    id: number
    name: string
    enrollmentEmployers: Array<{
      __typename?: 'EnrollmentEmployer'
      id: number
      inviteCode: string
      name?: string | null
      marketingFriendlyName?: string | null
      enrolledCount: number
      reachableCount: number
      address?: { __typename?: 'AddressDisplay'; line1?: string | null } | null
    }>
  } | null
}

export const PublicOrganizationDocument = `
    query PublicOrganization($inviteCode: String!) {
  publicOrganization(inviteCode: $inviteCode) {
    id
    name
    enrollmentEmployers {
      id
      inviteCode
      name
      marketingFriendlyName
      enrolledCount
      reachableCount
      address {
        line1
      }
    }
  }
}
    `
export const usePublicOrganizationQuery = <TData = PublicOrganizationQuery, TError = Error>(
  variables: PublicOrganizationQueryVariables,
  options?: UseQueryOptions<PublicOrganizationQuery, TError, TData>
) =>
  useQuery<PublicOrganizationQuery, TError, TData>(
    ['PublicOrganization', variables],
    fetchGql<PublicOrganizationQuery, PublicOrganizationQueryVariables>(
      PublicOrganizationDocument,
      variables
    ),
    options
  )

usePublicOrganizationQuery.getKey = (variables: PublicOrganizationQueryVariables) => [
  'PublicOrganization',
  variables,
]
